// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1b5fw","description":"PatientConsentPreview_description__3BeNm"};